import { Licensing } from '@adaptiva/core/licensing';
import { Provider, signal } from '@angular/core';
import { AidaService, LlmArtifactService, LlmChatService, LlmConversationService, LlmForkSearchService, LlmForkService, LlmHistoryService } from '../services';
import { AIDA_CHARACTER_LIMIT, AIDA_DISPLAY_NAME, AIDA_OEM_COMPATIBILITY_LIST, AIDA_WARNING_LIMIT, ARTIFACT_RENDERERS, ARTIFACT_TYPES } from '../tokens';
import { IAidaConfig } from './aida-config.interface';

export function provideAida(_config: Partial<IAidaConfig>): Provider[] {
	return [
		AidaService,
		LlmArtifactService,
		LlmChatService,
		LlmConversationService,
		LlmForkSearchService,
		LlmForkService,
		LlmHistoryService,
		{
			provide: AIDA_DISPLAY_NAME,
			useValue: signal(_config.displayName || 'Aida')
		},
		{
			provide: AIDA_CHARACTER_LIMIT,
			useValue: signal(_config.characterLimit || 2048)
		},
		{
			provide: AIDA_WARNING_LIMIT,
			useValue: signal(_config.warningThreshold ?? 0.8)
		},
		{
			provide: ARTIFACT_TYPES,
			useValue: new Set(_config.artifactTypes ?? [])
		},
		{
			provide: ARTIFACT_RENDERERS,
			useValue: _config.artifactRenderers ?? new Map()
		},
		{
			provide: AIDA_OEM_COMPATIBILITY_LIST,
			useValue: _config.oemCompatibility || [Licensing.Products.Internal.ADAPTIVA]
		},
	];
}
